import React, { useState, useEffect } from "react";
import MsgImage from "assets/svgIcons/MsgIcon";
import ControlIcon from "assets/svgIcons/ControlIcon";
import CartPathIcon from "assets/svgIcons/CarPathIcon";
import GeofenceIcon from "assets/svgIcons/GeofenceIcon";
import EditIcon from "assets/svgIcons/EditIcon";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import { DialogContainer } from "assets/css/globle";
import Button from "@mui/material/Button";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch } from "react-redux";

import {
  isUserBasic,
  isUserReadOnly,
  actionZoneTypes,
  featureKey,
  isFtPlusSite,
  canManageAzLimits,
  actionZoneLimits
} from "../../../../../constant";

import {
  SITEID_GLOBAL_STATE,
  MAP_GLOBAL_STATES, 
  SiteSetupAction 
} from "globalStore/globalStore";

import { useSelector } from "react-redux";

import {
  FilterContainer,
  ActionZoneWrapper,
  AddZoneActionWrapper,
  CarTypeBtnWrapper,
  AZNote,
} from "commonComponents/SideNav/subSectionNav/Map/MapStyled";

import { ActionZonesSubNav } from "./ActionZonesSubNav";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";

export const ActionZonesSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const [openEnforceActionZoneModal, setOpenEnforceActionZoneModal] = useState(false);
  const [isCommercial, setIsCommercial] = useState(false);
  const [hasShownZoneLimitPopup, setHasShownZoneLimitPopup] = useState(false);

  const { getUserRole, siteSettingsData, getCarPathActionZone } = useSelector((state) => state.commonReducers) || [];

  const {
    cartPathActionZone,
    geofenceActionZone,
    messageActionZone,
    controlsActionZone,
    addActionZonePolygon,
    openActionZoneWindow,
    deactiveAllAction,
    toggleDeactiveAllAction,
    mapDataGlobalState,
    editActionZonePolygonData,
    actionZoneButtonClicked,
    toggleAddActionZonePolygon,
    azLimitPopupOpen,
    azLimitPopupMessage
  } = useHookstate(MAP_GLOBAL_STATES);

  const {
    showAreas,
    showCenterOfGreens,
    showTeeMarkers,
    showPointsOfInterest,
    fleetType
  } = useHookstate(SiteSetupAction);

  const zoneCount = getCarPathActionZone?.length ?? 0;

  const isAzLimitSite = isFtPlusSite(fleetType.get()) && canManageAzLimits(getUserRole && getUserRole?.Role);
  const isAtOrOverZoneLimit = isAzLimitSite && zoneCount >= actionZoneLimits.MAX_ACTION_ZONES;

  useEffect(() => {
    setIsCommercial(siteSettingsData?.Features?.indexOf(featureKey.resortEdition) >= 0)
  }, [siteId.get(), siteSettingsData]);

    useEffect(() => {
    setHasShownZoneLimitPopup(false);
    azLimitPopupOpen.set(false);
  }, [siteId.get()]);

  // Watches zoneCount and fires popup once when crossing into at/over limit,
  // resets when count drops back under so it can fire again next time
useEffect(() => {
  if (!isAzLimitSite) {
    setHasShownZoneLimitPopup(false);
    return;
  }

  if (isAzLimitSite && zoneCount >= actionZoneLimits.MAX_ACTION_ZONES) {
    if (!hasShownZoneLimitPopup) {
      const message = zoneCount > actionZoneLimits.MAX_ACTION_ZONES
        ? `Reduce number of action zones from ${zoneCount} to ${actionZoneLimits.MAX_ACTION_ZONES} or below`
        : `Number of action zones has been reached (${zoneCount}/${actionZoneLimits.MAX_ACTION_ZONES})`;
      azLimitPopupMessage.set(message);
      azLimitPopupOpen.set(true);
      setHasShownZoneLimitPopup(true);
    }
  } else {
    setHasShownZoneLimitPopup(false);
  }
}, [zoneCount, isAzLimitSite, siteId.get()]);

  useEffect(() => {
    let messageZone = localStorage.getItem("messageActionZone");
    if (messageZone != null) 
      messageActionZone.set(JSON.parse(messageZone));
    else
      messageActionZone.set(true);   
  
    let controlZone = localStorage.getItem("controlsActionZone");
    if (controlZone != null) 
      controlsActionZone.set(JSON.parse(controlZone));
    else
      controlsActionZone.set(true); 
      
    let cartPathZone = localStorage.getItem("cartPathActionZone");
    if (cartPathZone != null) 
      cartPathActionZone.set(JSON.parse(cartPathZone));
    else
      cartPathActionZone.set(true); 
  
    let geofenceZone = localStorage.getItem("geofenceActionZone");
    if (geofenceZone != null) 
      geofenceActionZone.set(JSON.parse(geofenceZone));
    else
      geofenceActionZone.set(true);
      
    showAreas.set(false);
    showCenterOfGreens.set(false);
    showTeeMarkers.set(false);
    showPointsOfInterest.set(false);
  
    return () => {
      mapDataGlobalState.set(null);
    };
  }, []);
  
  useEffect(() => {
    if(siteSettingsData)
      deactiveAllAction.set(!siteSettingsData?.ActionZones);
  }, [siteSettingsData]);

  const enforceActionZoneNo = () => {
    setOpenEnforceActionZoneModal(false);
  };

  const enforceActionZoneYes = () => {
    deactiveAllAction.set(true);
    saveEnforceActionZones();
    setOpenEnforceActionZoneModal(false);
    toggleDeactiveAllAction.set((prev) => !prev);
  };

  const deactiveAllActionZone = () => {
    if (!addActionZonePolygon.get()) {
      openActionZoneWindow.set(false);
    }
    if (deactiveAllAction.get()) {
      deactiveAllAction.set(false);
      saveEnforceActionZones();    
      toggleDeactiveAllAction.set((prev) => !prev);
    } else {
      setOpenEnforceActionZoneModal(true);
    }
  };

  const saveEnforceActionZones = () => {
    dispatch(
      COMMON_SERVICES.putFleetSettingsServices({
        code: "AZ",
        Value: !deactiveAllAction.get(),
      }, siteId.get())
    ).then(() => {
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    });
  }

  const handleOnActionZoneButtons = (clickedButton) => {
    if (editActionZonePolygonData.get()?.actionZoneInfo?.Type === actionZoneTypes.NoSpeedRestriction &&
      !editActionZonePolygonData.get()?.actionZoneInfo?.IsGeofence &&
      !editActionZonePolygonData.get()?.actionZoneInfo?.IsCartPathOnly) {
        actionZoneButtonClicked.set(clickedButton);	      	
    } else {
      // eslint-disable-next-line default-case
      switch(clickedButton){
        case "messages":
          messageActionZone.set((prevState) => !prevState);
          localStorage.setItem("messageActionZone", messageActionZone.get());	
          break;
        case "control":
          controlsActionZone.set((prevState) => !prevState);
          localStorage.setItem("controlsActionZone", controlsActionZone.get());
          break;
        case "carpathonly":
          cartPathActionZone.set((prevState) => !prevState);
          localStorage.setItem("cartPathActionZone", cartPathActionZone.get());	
          break;
        case "geofence":
          geofenceActionZone.set((prevState) => !prevState);
          localStorage.setItem("geofenceActionZone", geofenceActionZone.get());
          break;
      }
    }
  }

  const addActionZone = () => {
    toggleAddActionZonePolygon.set((prev) => !prev);
  };

  return (
    <ActionZoneWrapper>
      <>
        <FilterContainer>
          <CarTypeBtnWrapper className="bdr">
            <button className={messageActionZone.get() ? "active" : ""} onClick={() => handleOnActionZoneButtons("messages")}>
              <MsgImage />
              {t("Messages")}
            </button>

            <button className={controlsActionZone.get() ? "active" : ""} onClick={() => handleOnActionZoneButtons("control")}>
              <ControlIcon />
              {t("Control")}
            </button>

            <button className={cartPathActionZone.get() ? "active" : ""} onClick={() => handleOnActionZoneButtons("carpathonly")}>              
              {isCommercial ? '*   ' : <CartPathIcon color="#636F7C" />}
              {isCommercial ? t("Action_Zone_groups") : t("Cart_Path_Only")}
            </button>

            <button className={geofenceActionZone.get() ? "active" : ""} onClick={() => handleOnActionZoneButtons("geofence")}>
              <GeofenceIcon />
              {t("Geofence")}
            </button>
          </CarTypeBtnWrapper>
          {deactiveAllAction.get() ? <AZNote>{t("Action_Zones_disabled")}</AZNote>:<></>}
          <AddZoneActionWrapper>
            {window.innerWidth > 850 && (
              <button
                disabled={
                  isUserBasic(getUserRole && getUserRole?.Role) ||
                  isUserReadOnly(getUserRole && getUserRole?.Role) ||
                  isAtOrOverZoneLimit
                }
                className={addActionZonePolygon.get() ? "add-zone active" : ""}
                onClick={addActionZone}
                style={
                  isAzLimitSite && zoneCount >= actionZoneLimits.ZONE_WARNING_THRESHOLD
                    ? { border: `2px solid ${isAtOrOverZoneLimit ? '#d32f2f' : '#ed6c02'}` }
                    : {}
                }
              >
                <EditIcon />
                {t("Add_Zone")}
              </button>
            )}
            <button
              onClick={deactiveAllActionZone}
              disabled={
                isUserBasic(getUserRole && getUserRole?.Role) ||
                isUserReadOnly(getUserRole && getUserRole?.Role)
              }
            >
              {deactiveAllAction.get() ? "Activate All" : t("Deactivate_all")}
            </button>
          </AddZoneActionWrapper>
        </FilterContainer>{" "}
      </>

      <Dialog
        aria-labelledby="draggable-dialog-title"
        open={openEnforceActionZoneModal}
        onClose={enforceActionZoneNo}
      >
        <DialogContainer>
          <h2 className="header">{t("Confirm")}</h2>
          <p className="content">
            {" "}
            {t("Are_you_sure_that_you_want_to_stop_enforcement_of_action_zones")}
            ?
          </p>
          <DialogActions className="action-wrapper">
            <Button onClick={enforceActionZoneYes}>{t("Yes")}</Button>
            <Button onClick={enforceActionZoneNo}>{t("No")}</Button>
          </DialogActions>
        </DialogContainer>
      </Dialog>

      <Dialog
        aria-labelledby="az-limit-dialog-title"
        open={azLimitPopupOpen.get()}
        onClose={() => azLimitPopupOpen.set(false)}
      >
        <DialogContainer>
          <p className="content" style={{ paddingTop: "30px" }}>{azLimitPopupMessage.get()}</p>
          <DialogActions className="action-wrapper">
            <Button onClick={() => azLimitPopupOpen.set(false)}>{t("Ok")}</Button>
          </DialogActions>
        </DialogContainer>
      </Dialog>

      {openActionZoneWindow.get() ? <ActionZonesSubNav /> : null}
    </ActionZoneWrapper>
  );
};